import React, { memo, useState } from 'react';
import { Modal, Box, Button, FormControl, Select, MenuItem, Checkbox, FormControlLabel, IconButton, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



// export default AssignedClinicianModal;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    width: { xs: '90%', sm: '80%', md: '45%' },
};

const closeButtonStyle = {
    position: 'absolute',
    top: 10,
    right: 10,
};

const AssignedClinicianModal = ({
    open,
    onClose,
    title,
    options,
    listItems,
    onOptionChange,
    onCheckboxChange,
    selectedOption,
    isChecked,
    onSubmit,
}) => {
    console.log("listItem", listItems)
    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <IconButton onClick={onClose} sx={closeButtonStyle}>
                    <CloseIcon />
                </IconButton>
                <h2>{title}</h2>
                <FormControl fullWidth style={{ marginTop: 20 }}>
                    <Select value={selectedOption} onChange={onOptionChange} displayEmpty>
                        <MenuItem value="">
                            <em>Choose an option</em>
                        </MenuItem>
                        {options.map((option) => (
                            <MenuItem key={option.ID} value={option.ID}>
                                {option.RoleName + " (No Of Eligible Candidates: " + option.Count + ")"}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box sx={{ maxHeight: 300, overflowY: 'auto', marginTop: 2 }}>
                    {listItems.map((item) => (
                        <Box key={item.ID}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isChecked.includes(item.ID)}
                                        onChange={(e) => onCheckboxChange(e, item.ID)}
                                        disabled={item.assignedClinician && item.assignedClinician.length > 0}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <span>{item.FULL_NAME}</span>
                                        <span>Role: ({item.ROLE_NAME})</span>
                                        {item.assignedClinician && item.assignedClinician.length > 0 && (
                                            <span style={{ color: 'red' }}>(Clinician assigned)</span> // Optional: Add a note
                                        )}
                                    </Box>
                                }
                            />
                        </Box>
                    ))}
                </Box>

                <Box display="flex" justifyContent="center">
                    <Button variant="contained" sx={{ marginTop: 2 }} onClick={onSubmit}>
                        Submit
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default memo(AssignedClinicianModal);